import { render, staticRenderFns } from "./Recipient.vue?vue&type=template&id=44ee3d74&scoped=true&"
import script from "./Recipient.vue?vue&type=script&lang=js&"
export * from "./Recipient.vue?vue&type=script&lang=js&"
import style0 from "./Recipient.vue?vue&type=style&index=0&id=44ee3d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee3d74",
  null
  
)

export default component.exports